import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, inject, PLATFORM_ID, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule, MatLabel } from '@angular/material/input';
import { AuthService } from '../../../../core/services/auth.service';
import { SuccessError } from '../../../general/components/success-error/success-error';
import { LoaderComponent } from '../../../general/components/loader/loader.component';
import { HapticsService } from '../../../general/services/haptics.service';
import { GtmService } from '../../../../core/services/gtm.service';
import { SeoService } from '../../../services/seo.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-forgot-password',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatLabel,
    MatIconModule,
    MatCardModule,
    SuccessError,
    LoaderComponent
  ],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss',
})
export class ForgotPasswordComponent implements OnInit {
  private authService = inject(AuthService);
  private haptics = inject(HapticsService);
  private gtm = inject(GtmService);
  private cdr = inject(ChangeDetectorRef);

  submitted = false;
  success = false;
  email: string | undefined;
  loading = false;
  platformId = inject(PLATFORM_ID);
  private seo = inject(SeoService);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.scrollTop = 0;
      this.gtm.pageView({
        page_path: '/forgot-password',
        page_title: 'Forgot Password | Horizinns'
      });
    }
    this.seo.updateMetaTags('Forgot Passwor', 'Forgot Password for Horizinns', undefined, `${environment.appUrl}/forgot-password}`);
  }
  submit = () => {
    this.haptics.click();
    this.submitted = true;
    this.loading = true;
    console.log('email', this.email);
    if (this.email) {
      this.authService.resetPasswordRequest(this.email).subscribe({
        next: () => {
          this.success = true;
          this.loading = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.success = false;
          this.loading = false;
          this.cdr.detectChanges();
        }
      });
    }
  }
}
